import { Avatar } from '../avatar';
import { Col } from '../col';
import { Row } from '../row';
import { Text } from '../typography';

type P = {
  email: string;
  name: string;
  src?: string;
};

// TODO: move to ui
const AvatarOption = ({ email, name, src }: P) => (
  <Row align="middle" gutter={['ms', 0]}>
    <Col>
      <Avatar size="sm" src={src} />
    </Col>
    <Col flex="1">
      <Row>
        <Col span={24}>
          {/* TODO: should be primary color, check it with designers */}
          <Text type="title">{name}</Text>
        </Col>
        <Col span={24}>
          <Text size="small" type="secondary">
            {email}
          </Text>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default AvatarOption;
